import axios from "axios";

export default axios.create({
	baseURL: process.env.NODE_ENV === "production" 
		? "https://api-ct01-boxidiomas.moreevents.com.br"
		: "http://localhost:3030",
});
